var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5952 22.758C7.5952 24.8503 5.90412 26.5414 3.81176 26.5414C1.7194 26.5414 0.0283203 24.8503 0.0283203 22.758C0.0283203 20.6656 1.7194 18.9745 3.81176 18.9745H7.5952V22.758ZM9.48692 22.758C9.48692 20.6656 11.178 18.9745 13.2704 18.9745C15.3627 18.9745 17.0538 20.6656 17.0538 22.758V32.2166C17.0538 34.3089 15.3627 36 13.2704 36C11.178 36 9.48692 34.3089 9.48692 32.2166V22.758Z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2707 7.56688C11.1783 7.56688 9.48726 5.8758 9.48726 3.78344C9.48726 1.69108 11.1783 0 13.2707 0C15.3631 0 17.0541 1.69108 17.0541 3.78344V7.56688H13.2707ZM13.2707 9.48726C15.3631 9.48726 17.0541 11.1783 17.0541 13.2707C17.0541 15.3631 15.3631 17.0541 13.2707 17.0541H3.78344C1.69108 17.0541 0 15.3631 0 13.2707C0 11.1783 1.69108 9.48726 3.78344 9.48726H13.2707Z",
    fill: "#36C5F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4332 13.2707C28.4332 11.1783 30.1243 9.48726 32.2166 9.48726C34.309 9.48726 36.0001 11.1783 36.0001 13.2707C36.0001 15.3631 34.309 17.0541 32.2166 17.0541H28.4332V13.2707ZM26.5415 13.2707C26.5415 15.3631 24.8504 17.0541 22.758 17.0541C20.6657 17.0541 18.9746 15.3631 18.9746 13.2707V3.78344C18.9746 1.69108 20.6657 0 22.758 0C24.8504 0 26.5415 1.69108 26.5415 3.78344V13.2707Z",
    fill: "#2EB67D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.758 28.4331C24.8504 28.4331 26.5415 30.1242 26.5415 32.2166C26.5415 34.3089 24.8504 36 22.758 36C20.6657 36 18.9746 34.3089 18.9746 32.2166V28.4331H22.758ZM22.758 26.5414C20.6657 26.5414 18.9746 24.8503 18.9746 22.758C18.9746 20.6656 20.6657 18.9745 22.758 18.9745H32.2453C34.3377 18.9745 36.0287 20.6656 36.0287 22.758C36.0287 24.8503 34.3377 26.5414 32.2453 26.5414H22.758Z",
    fill: "#ECB22E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackIcon);
export default __webpack_public_path__ + "static/media/SlackIcon.781e0c95e217d30d5f49378b56b9fef7.svg";
export { ForwardRef as ReactComponent };